<template>
  <sub-page :title="title">
    <div class="verify-page">
      <div class="notice-card">
        <div class="notice-title">基础信息核对工作须知</div>
        <div class="notice-content">
          <p>一、为更好地向个人和用人单位提供人社精准推送公共服务，全省人社部门从2023年3月16日开展个人和用人单位基础信息核对工作。</p>
          <p>二、为有序推进核对工作，信息系统设置了3次核对告知提醒，您在办理业务时可跳过前2次告知提醒，但第3次必须完成核对工作后方可办理人社高频服务事项和查询事项。</p>
        </div>
      </div>
      <div class="btn-area">
        <button class="skip-btn" @click="handleSkip">跳过</button>
        <button class="confirm-btn" @click="handleConfirm">确认</button>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'InfoVerify',
  components: { SubPage },
  data() {
    return {
      title: '基础信息核对'
    }
  },
  methods: {
    handleSkip() {
      this.$router.back()
    },
    handleConfirm() {
      this.$router.push('/social-card-query')
    }
  }
}
</script>

<style scoped>
.verify-page {
  background: #F3F8FB;
  min-height: 100%;
  padding: calc(32 * var(--w));
}
.notice-card {
  background: #fff;
  border-radius: calc(8 * var(--w));
  padding: calc(48 * var(--w)) calc(32 * var(--w));
}
.notice-title {
  font-size: calc(44 * var(--w));
  font-weight: 500;
  color: #323233;
  text-align: center;
  margin-bottom: calc(48 * var(--w));
}
.notice-content {
  font-size: calc(36 * var(--w));
  color: #323233;
  line-height: 1.8;
}
.notice-content p {
  margin-bottom: calc(32 * var(--w));
  text-indent: calc(72 * var(--w));
}
.btn-area {
  display: flex;
  gap: calc(24 * var(--w));
  margin-top: calc(60 * var(--w));
}
.skip-btn {
  flex: 1;
  height: calc(88 * var(--w));
  background: #fff;
  color: #323233;
  font-size: calc(40 * var(--w));
  border: 1px solid #dcdee0;
  border-radius: calc(8 * var(--w));
  cursor: pointer;
}
.confirm-btn {
  flex: 1;
  height: calc(88 * var(--w));
  background: #2E8CF6;
  color: #fff;
  font-size: calc(40 * var(--w));
  border: none;
  border-radius: calc(8 * var(--w));
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/InfoVerify.vue